import { useRef, useEffect } from "react";
import mixitup from "mixitup";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import bg from "../../assets/image/courses_background.jpg";
import img1 from "../../assets/image/course_1.jpg";
import img2 from "../../assets/image/course_2.jpg";
import img3 from "../../assets/image/course_3.jpg";

const PopularOnline = () => {
  return (
    <div className="courses" style={{ backgroundImage: `url(${bg})` }}>
      <div className="section_background parallax-window"></div>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="section_title_container text-center">
              <h2 className="section_title">Popular Online Courses</h2>
              <div className="section_subtitle">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec
                  vel gravida arcu. Vestibulum feugiat, sapien ultrices
                  fermentum congue, quam velit venenatis sem
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row courses_row">
          <div className="col-lg-4 course_col">
            <div className="course">
              <div className="course_image">
                <img src={img1} alt="" />
              </div>
              <div className="course_body">
                <h3 className="course_title">
                  <a href="course.html">Software Training</a>
                </h3>
                <div className="course_teacher">Mr. John Taylor</div>
                <div className="course_text">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi elitsed do
                    eiusmod tempor
                  </p>
                </div>
              </div>
              <div className="course_footer">
                <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                  <div className="course_info">
                    <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                    <span>20 Student</span>
                  </div>
                  <div className="course_info">
                    <i className="fa fa-star" aria-hidden="true"></i>
                    <span>5 Ratings</span>
                  </div>
                  <div className="course_price ml-auto">$130</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 course_col">
            <div className="course">
              <div className="course_image">
                <img src={img2} alt="" />
              </div>
              <div className="course_body">
                <h3 className="course_title">
                  <a href="course.html">Developing Mobile Apps</a>
                </h3>
                <div className="course_teacher">Ms. Lucius</div>
                <div className="course_text">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi elitsed do
                    eiusmod tempor
                  </p>
                </div>
              </div>
              <div className="course_footer">
                <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                  <div className="course_info">
                    <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                    <span>20 Student</span>
                  </div>
                  <div className="course_info">
                    <i className="fa fa-star" aria-hidden="true"></i>
                    <span>5 Ratings</span>
                  </div>
                  <div className="course_price ml-auto">Free</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 course_col">
            <div className="course">
              <div className="course_image">
                <img src={img3} alt="" />
              </div>
              <div className="course_body">
                <h3 className="course_title">
                  <a href="course.html">Starting a Startup</a>
                </h3>
                <div className="course_teacher">Mr. Charles</div>
                <div className="course_text">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipi elitsed do
                    eiusmod tempor
                  </p>
                </div>
              </div>
              <div className="course_footer">
                <div className="course_footer_content d-flex flex-row align-items-center justify-content-start">
                  <div className="course_info">
                    <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                    <span>20 Student</span>
                  </div>
                  <div className="course_info">
                    <i className="fa fa-star" aria-hidden="true"></i>
                    <span>5 Ratings</span>
                  </div>
                  <div className="course_price ml-auto">
                    <span>$320</span>$220
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="courses_button trans_200">
              <a href="#">view all courses</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularOnline;
